import React from 'react';
import { Grid, Container } from '@material-ui/core/';
import { connect } from 'react-redux';
import {setItemCategories, setGasItemCategories, setItemQuestionnaire, setItemAlerts, setItemHer } from '../../../../helpers/disagg101Helper';
import { getUserLocale, replaceTokensInStrings} from '../../../../helpers/helper';
import { WIDGETS } from '../../../../constants/common';

class DisaggBody extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      itemCategories: [],
      itemQuestionnaire: [],
      itemAlerts:[],
      itemHer:[],
      gasItemCategories:[]
    };
  }

    componentDidMount () {
    if(this.props.configs.data["disagg101.utilitytype"] === 'electric') {
      let itemCategories = setItemCategories(this.props);
      let itemQuestionnaire = setItemQuestionnaire(this.props);
      this.setState({
        itemCategories: itemCategories,
        itemQuestionnaire: itemQuestionnaire
      })
    }else {
      let gasItemCategories = setGasItemCategories(this.props);
      let itemAlerts = setItemAlerts(this.props);
      let itemHer = setItemHer(this.props);
      this.setState({
        gasItemCategories: gasItemCategories,
        itemAlerts: itemAlerts, 
        itemHer: itemHer
      })
    }
  }

  render () {
    let itemCategories = this.state.itemCategories;
    let itemQuestionnaire = this.state.itemQuestionnaire;
    let itemAlerts = this.state.itemAlerts;
    let itemHer = this.state.itemHer;
    let gasItemCategories =this.state.gasItemCategories;
    let elecText = this.props.translations.data['DISAGG101_AIE.TEASER_TEXT'];
    let gasText = this.props.translations.data['DISAGG101_PO.HEADLINE'];
    let eleCatDesc = this.props.translations.data['DISAGG101_AIC.SUB_HEADLINE'];
    let gasCatDesc = this.props.translations.data['DISAGG101_AICGAS.SUB_HEADLINE'];
    let itemCat = (this.props.configs.data["disagg101.utilitytype"] === 'electric' ? [...itemCategories] : [...gasItemCategories]);
    let itemQues = (this.props.configs.data["disagg101.utilitytype"] === 'electric' ? [...itemQuestionnaire] : [...itemAlerts]);

    const getDisplayText = (answer) => {
      let tokenMappings = [
        { key: "{privacyLink}", value: this.props.configs.data ? this.props.configs.data["privacyLink_" + getUserLocale(this.props.configs.data)] : "#" },
        { key: "{className}", value: "link"},
        { key: "{tosLinkUrl}", value: this.props.configs.data ? this.props.configs.data["termsLink_" + getUserLocale(this.props.configs.data)] : "#" },
      ];
      answer = replaceTokensInStrings(answer, tokenMappings);
      return answer;
    };

    const herContent = () =>{
          let herQuestions = itemHer.map((item,index)=>{
            return(
              <div className='disagg-questionnaire' key={index}>
                <div className='question'>{item.question}</div>
                <div className='answer' dangerouslySetInnerHTML={{ __html: item.answer}}></div>
              </div>
          )})
            return(
              <>
                <div className='title title-2'>
                  {this.props.translations.data['DISAGG101_HER.HEADLINE']}
                </div>
                <div className='disagg-content'>
                  {herQuestions}
                </div>
              </>
            )
        } 

    return (
      <>
        <div className='disagg-body-container'>
          <Container className='disagg-body' maxWidth='lg'>
            <div className='disagg-body-header'>
              <div className='title'>
              <span data-widget-name={WIDGETS.FAQ} data-text-color="color_2">{(this.props.configs.data["disagg101.utilitytype"] === 'electric' ? elecText : gasText )}</span>
              </div>
              <div className='disagg-content'>
                {itemQues.map((item, index) => (
                  <div className='disagg-questionnaire' key={index}>
                    <div className='question'><span data-widget-name={WIDGETS.FAQ} data-text-color="color_1">{item.question}</span></div>
                    <div className='answer' dangerouslySetInnerHTML={{ __html: getDisplayText(item.answer)}} data-widget-name={WIDGETS.FAQ} data-text-color="color_3"></div>
                  </div>
                ))}
              </div>
              {this.props.configs.data["disagg101.utilitytype"] === 'gas' ? herContent() : ""}
            </div>

            <div className='disagg-categories'>
              <div className='disagg-inner-container'>
                <h2 className='categories'>
                <span data-widget-name={WIDGETS.FAQ} data-text-color="color_2">{this.props.translations.data['DISAGG101_AIC.HEADLINE']}</span>
                </h2>
                <div className='body'>
                <span data-widget-name={WIDGETS.FAQ} data-text-color="color_3">{(this.props.configs.data["disagg101.utilitytype"] === 'electric' ? eleCatDesc : gasCatDesc )}</span>
                </div>
              </div>
            </div>
             <div className='item-categories'>
             <Grid container spacing={2} className='item-cat-container'>
              {itemCat.map((item, index) => {
                return(
                <Grid item md={6} sm={6} className='item' key={index}>
                  <div className="icon-wrapper">
                      <img
                        className='app-icon'
                        src={item.image}
                        alt={item.title}
                      />
                    </div>
                  <div className='title'><span data-widget-name={WIDGETS.FAQ} data-text-color="color_3">{item.title}</span></div>
                    <div className='desc' dangerouslySetInnerHTML={{ __html: getDisplayText(item.description) }} data-widget-name={WIDGETS.FAQ} data-text-color="color_3"></div>
                </Grid>
              )})}
            </Grid>
            </div>
          </Container>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    translationsData: state.translationsData,
    configs: state.configs
  }
}

export default connect(mapStateToProps)(DisaggBody)
